 // ARCHIVO AUTO-GENERADO. LOS CAMBIOS SE DESTRUIRÁN.

import {UploadIds} from './Upload'
import {Tables} from './Tables'
import {Align} from 'sopix/db/db-types'
import {tableColumns} from 'sopix/db/TableColumns'
import {SimpleColumn} from 'sopix/db/dbColumn'

export const UploadCol = Object.freeze({
    idUpload : new SimpleColumn(UploadIds.idUpload, 11, 11, Align.RIGHT),
    path : new SimpleColumn(UploadIds.path, 40, 16, Align.LEFT),
})

tableColumns[Tables.Upload] = UploadCol
